// src/routes/ordersRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import Orders from '../pages/orders/Orders';
import OrderDetail from '../pages/orders/OrderDetail';
import ProtectedRoute from '../components/global/ProtectedRoute';

const ordersRoutes = (
    <>
        <Route
            path="/orders"
            element={
                <ProtectedRoute requiredPermission="orders.manage">
                    <Orders />
                </ProtectedRoute>
            }
        />
        <Route
            path="/orders/:id"
            element={
                <ProtectedRoute requiredPermission="orders.manage">
                    <OrderDetail />
                </ProtectedRoute>
            }
        />
    </>
);

export default ordersRoutes;
